module.exports = __webpack_public_path__ + "images/finishes-0f7651c457eade9927457f2981e97428.jpg";